export const TASK_STATES = {
  PROCESSING: 'processing',
  QUEUED: 'queued',
  COMPLETED: 'completed',
} as const;

export const BADGE_TYPES = {
  SAVING: 'saving',
  PENDING: 'pending',
  COMPLETED: 'completed',
  SAVED: 'saved',
} as const;

export type TaskState = typeof TASK_STATES[keyof typeof TASK_STATES];
export type BadgeType = typeof BADGE_TYPES[keyof typeof BADGE_TYPES];

export interface PixieTask {
  id: string;
  patient: string;
  type: string;
  provider: string;
  state: TaskState;
  progress?: number;
  timeSaved?: string;
}
